import React from 'react';
import { ArrowRight } from 'lucide-react';
export function WorkforcePartner() {
  return <section className="py-24 px-6 md:px-12 bg-white" data-id="element-149">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-150">
        {/* Image with offset border */}
        <div className="relative pl-6 pb-6" data-id="element-151">
          {/* Blue offset border (bottom left) */}
          <div className="absolute bottom-0 left-0 w-[90%] h-[90%] border-8 border-primary z-0" data-id="element-152"></div>
          <img src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?q=80&w=1000&auto=format&fit=crop" alt="Welder working on pipe" className="relative z-10 w-full h-[500px] object-cover shadow-xl" data-id="element-153" />
        </div>

        {/* Content */}
        <div data-id="element-154">
          <div className="section-badge" data-id="element-155">ABOUT BND CONTRACTING</div>
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-6 leading-tight" data-id="element-156">
            A WORKFORCE PARTNER THAT PUTS{' '}
            <span className="text-primary" data-id="element-157">CRAFTSMEN FIRST</span>
          </h2>
          <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-158">
            Since 2010, BND has built a reputation on a simple philosophy: treat
            craftsmen with respect, provide steady work, and prioritize safety
            above all else. We know that our success is directly tied to the
            success of our workforce. That's why we offer competitive
            compensation, comprehensive benefits, and a dedicated support team
            that understands the realities of working in the trades.
          </p>
          <button className="btn-white border border-gray-200 shadow-sm w-fit group" data-id="element-159">
            LEARN MORE
            <div className="bg-primary text-white rounded-full p-1 group-hover:bg-primary-hover transition-colors" data-id="element-160">
              <ArrowRight size={16} data-id="element-161" />
            </div>
          </button>
        </div>
      </div>
    </section>;
}